export default __webpack_public_path__ + "static/media/denice.6821e91b.png";